export const SHOW_REGISTER_FORM_PAGE = 'events/SHOW_REGISTER_FORM_PAGE';

/**
 * @return {{type: string}}
 */
export const showRegisterFormPage = (show) => ({
  type: SHOW_REGISTER_FORM_PAGE,
  payload: show,
});
